module.exports = __webpack_public_path__ + "static/media/search.9d8d9ecb.svg";